export default (date) =>
  Object.prototype.toString.call(date) === '[object Date]'
